import { useStateRef } from '@op/hooks/common';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getRealtimeSteamingTrend } from '@op/services';
import { useEffect } from 'react';

export function useRealTimeTrendAnalysis({
  filter,
  addRefreshTask,
  emptyCallback,
  isGST
}: {
  filter: any;
  addRefreshTask: (key: string, func: () => Promise<void>) => void;
  emptyCallback?: () => void;
  isGST?: boolean;
}) {
  const [dataRef, data, setData] = useStateRef<any>({});
  const { loading, wrapperCancelRequest } = useCancelRequestHook({
    clear: () => setData({}),
  });
  function formatTimeline(timeline: any[], topTopics: Array<string>) {
    return (timeline || []).map((item) => ({
      ...item,
      showTopic: topTopics?.includes(item.time),
    }));
  }

  function requestTimeline(defaultLoading?: boolean) {
    return wrapperCancelRequest(
      getRealtimeSteamingTrend,
      isGST ? filter : { ...filter, feed_source: 'real_time_streaming' },
      defaultLoading,
      {
        user_cache_expire: 5,
      },
    ).then((data) => {
      const { timeline, top_time_list } = data || {};
      const formattedTimeline = formatTimeline(timeline, top_time_list);
      const isEmpty =
        !Array.isArray(formatTimeline) ||
        !formatTimeline.some((val) => val.mentions > 0);

      if (isEmpty) {
        emptyCallback?.();
      }

      setData({
        ...data,
        timeline: formattedTimeline,
        isEmpty,
      });
    });
  }

  useEffect(() => {
    if (filter) {
      requestTimeline();
      addRefreshTask('realtimeTrend', () => requestTimeline(true));
    }
  }, [filter]);

  return { dataRef, data, loading, refetch: requestTimeline };
}
